import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getUnreadInternalCount } from "../api";
import "./Sidebar.css";

const ICON_PROPS = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const InboxIcon = () => (
  <svg {...ICON_PROPS}>
    <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5z" />
    <path d="M4 13h4l2 3h4l2-3h4" />
  </svg>
);

const SentIcon = () => (
  <svg {...ICON_PROPS}>
    <path d="M5 12L20 5l-4 15-4.5-5.5z" />
    <path d="M11.5 14.5L16 5" />
  </svg>
);

const InternalIcon = () => (
  <svg {...ICON_PROPS}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const LogIcon = () => (
  <svg {...ICON_PROPS}>
    <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="3" width="6" height="4" rx="1" />
    <path d="M9 12h6M9 16h4" />
  </svg>
);

const SettingsIcon = () => (
  <svg {...ICON_PROPS}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

export default function Sidebar({ activePage, isSuperuser }) {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    function fetchUnread() {
      getUnreadInternalCount()
        .then(data => setUnreadCount(data.unread_count || 0))
        .catch(() => {});
    }
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="sidebar">
      <button
        className={`sidebar-btn ${activePage === "inbox" ? "active" : ""}`}
        onClick={() => navigate("/dashboard")}
        data-tooltip="შემოსული ფოსტა"
      >
        <span className="sidebar-icon"><InboxIcon /></span>
        <span className="sidebar-label">ფოსტა</span>
      </button>

      <button
        className={`sidebar-btn ${activePage === "sent" ? "active" : ""}`}
        onClick={() => navigate("/sent")}
        data-tooltip="გაგზავნილი წერილები"
      >
        <span className="sidebar-icon"><SentIcon /></span>
        <span className="sidebar-label">გაგზავნილი</span>
      </button>

      <button
        className={`sidebar-btn ${activePage === "internal" ? "active" : ""}`}
        onClick={() => navigate("/internal-messages")}
        data-tooltip="შიდა კომუნიკაცია"
      >
        <span className="sidebar-icon"><InternalIcon /></span>
        <span className="sidebar-label">შიდა</span>
        {unreadCount > 0 && (
          <span className="sidebar-badge">{unreadCount}</span>
        )}
      </button>

      {isSuperuser && (
        <>
          <button
            className={`sidebar-btn ${activePage === "audit" ? "active" : ""}`}
            onClick={() => navigate("/audit-log")}
            data-tooltip="აუდიტის ჟურნალი"
          >
            <span className="sidebar-icon"><LogIcon /></span>
            <span className="sidebar-label">ლოგი</span>
          </button>
          <button
            className={`sidebar-btn ${activePage === "settings" ? "active" : ""}`}
            onClick={() => navigate("/settings")}
            data-tooltip="პარამეტრები"
          >
            <span className="sidebar-icon"><SettingsIcon /></span>
            <span className="sidebar-label">სხვა</span>
          </button>
        </>
      )}
    </div>
  );
}
